import { createAction } from 'redux-act';
import fetch from 'axios';
import { notify } from 'reapop';

/**
 * Create the action
 */

const request = createAction('SEND_MAIL_REQUEST');
const success = createAction('SEND_MAIL_SUCCESS');
const error = createAction('SEND_MAIL_ERROR');

function sendMail(data) {
    return function (dispatch) {
        // Dispatch the request action
        dispatch(request);

        return fetch
            .post('/api/mail/send', data)
            .then(({ result }) => {
                dispatch(
                    notify({
                        message: 'Uw bericht is verzonden!',
                        dismissible: true,
                        status: 'success',
                        position: 'tc',
                    })
                );
                // Dispatch success action
                dispatch(success(result));
            })
            .catch((err) => {
                dispatch(
                    notify({
                        message: 'Er is iets mis gegaan.',
                        dismissible: true,
                        status: 'error',
                        position: 'tc',
                    })
                );
                dispatch(error(err));
                throw err;
            });
    };
}

/**
 * Export the components
 */

export { sendMail as default };
export { request, success, error };
